module.exports = __webpack_public_path__ + "static/media/bg-silver.88890bf4.png";